"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelEdit = exports.FormModel = exports.FormModelMutator = void 0;
const core_api_1 = require("@ikegps/core-api");
const id_1 = require("../../id");
const form_metadata_1 = require("./form.metadata");
const form_state_1 = require("./form.state");
const form_subform_1 = require("./subform/form.subform");
class FormModelMutator extends form_subform_1.FormModelMutatorSubForm {
    displayName(displayName) {
        this.state.setDisplayName(displayName);
    }
    description(description) {
        this.state.setDescription(description);
    }
}
exports.FormModelMutator = FormModelMutator;
class FormModel extends form_subform_1.FormModelFieldSubForm {
    get state() {
        return (this._state = this._state || new form_state_1.FormModelState(this));
    }
    get Mutator() {
        if (this._FMutator == null) {
            this._FMutator = new FormModelMutator(this);
        }
        return this._FMutator;
    }
    get id() {
        return this.state.id;
    }
    set id(v) {
        this.state.id = v;
    }
    get revision() {
        return this.state.revision;
    }
    set revision(v) {
        this.state.revision = v;
    }
    get version() {
        return this.state.version;
    }
    set version(v) {
        this.state.version = v;
    }
    get rootFormId() {
        return this.state.rootFormId;
    }
    set rootFormId(v) {
        this.state.rootFormId = v;
    }
    get name() {
        return this.state.name;
    }
    set name(v) {
        this.state.name = v;
    }
    get description() {
        return this.state.description;
    }
    set description(v) {
        this.state.description = v;
    }
    get displayName() {
        return this.state.displayName;
    }
    set displayName(v) {
        this.state.displayName = v;
    }
    get displayVersion() {
        return this.state.displayVersion;
    }
    set displayVersion(v) {
        this.state.displayVersion = v;
    }
    get updatedAt() {
        return this.state.updatedAt;
    }
    set updatedAt(v) {
        this.state.updatedAt = v;
    }
    get createdAt() {
        return this.state.createdAt;
    }
    set createdAt(v) {
        this.state.createdAt = v;
    }
    get updatedBy() {
        return this.state.updatedBy;
    }
    set updatedBy(v) {
        this.state.updatedBy = v;
    }
    get metadata() {
        return this.state.metadata;
    }
    set metadata(v) {
        this.state.metadata = v;
    }
    get spanSubForm() {
        var _a;
        const potentialField = (_a = this.fields.find((field) => form_subform_1.FormModelFieldSubForm.isSubForm(field) && field.subFormType === core_api_1.SubFormType.SPAN)) !== null && _a !== void 0 ? _a : null;
        return potentialField;
    }
    constructor() {
        super(null, null);
        this._state = new form_state_1.FormModelState(this);
        this._FMutator = new FormModelMutator(this);
        this.revision = id_1.IkeId.generate();
        this.version = this.revision;
        this.rootFormId = this.revision;
        this.metadata = new form_metadata_1.FormModelMetadata(this);
    }
    getForm() {
        return this;
    }
    get stateValue() {
        var _a;
        const fieldState = this.state.getFieldValue(this.fieldId);
        return {
            id: this.id,
            displayName: this.state.displayName,
            fields: (_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.fields) !== null && _a !== void 0 ? _a : [],
            label: [],
            type: 'form',
            subFormType: fieldState === null || fieldState === void 0 ? void 0 : fieldState.subFormType,
        };
    }
}
exports.FormModel = FormModel;
class FormModelEdit extends FormModel {
    constructor(form, state) {
        super();
        this.formModel = form;
        this.revision = form.revision;
        this._state = state;
    }
}
exports.FormModelEdit = FormModelEdit;
//# sourceMappingURL=form.js.map